import { render, staticRenderFns } from "./wp_points.vue?vue&type=template&id=49d8a8df&scoped=true&"
import script from "./wp_points.vue?vue&type=script&lang=js&"
export * from "./wp_points.vue?vue&type=script&lang=js&"
import style0 from "./wp_points.vue?vue&type=style&index=0&id=49d8a8df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8a8df",
  null
  
)

export default component.exports